// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1455":"8a0e3636","2589":"8a0e3636","5901":"8a0e3636","6937":"8a0e3636","8747":"47d75336"}[chunkId] + ".chunk.css";
};